import { NgModule } from "@angular/core";
import { Routes, RouterModule, ROUTES } from "@angular/router";
import { GlobalSettingsComponent } from "./global-settings.component";
import { DatabaseConnectionsComponent } from "./database-connections/database-connections.component";
import { EmailNotificationProfilesComponent } from "./email-notification-profiles/email-notification-profiles.component";
import { IS_SAAS } from "@coso/utility";

export function routesFactory(isSaaS: boolean): Routes {
  const routes: Routes = [
    {
      path: "",
      component: GlobalSettingsComponent,
      children: [
          {
            path: "",
            redirectTo: isSaaS ? "email-notification-profiles" : "database-connections",
            pathMatch: "full"
          },
          {
            path: "email-notification-profiles",
            component: EmailNotificationProfilesComponent
          }
      ]
    }
  ];

  if (!isSaaS) {
    routes[0].children.push({
      path: "database-connections",
      component: DatabaseConnectionsComponent
    });
  }

  return routes;
}

@NgModule({
  imports: [RouterModule.forChild([])],
  exports: [RouterModule],
  providers: [
    {
      provide: ROUTES,
      useFactory: routesFactory,
      deps: [IS_SAAS],
      multi: true
    }
  ]
})
export class GlobalSettingsRoutingModule {}
